import React, { useRef, useCallback } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface RecaptchaComponentProps {
  onVerify: (token: string | null) => void;
  onExpired?: () => void;
  onError?: () => void;
  size?: 'compact' | 'normal';
  theme?: 'light' | 'dark';
}

export const RecaptchaComponent: React.FC<RecaptchaComponentProps> = ({
  onVerify,
  onExpired,
  onError,
  size = 'normal',
  theme = 'light'
}) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const siteKey = '6LcN24IrAAAAAL9dVSnweM_PBgh-v_iG4A070zYT';

  const handleChange = useCallback((token: string | null) => {
    onVerify(token);
  }, [onVerify]);

  const handleExpired = useCallback(() => {
    onVerify(null);
    onExpired?.();
  }, [onVerify, onExpired]);

  const handleError = useCallback(() => {
    onVerify(null);
    onError?.();
  }, [onVerify, onError]);

  if (!siteKey) {
    console.warn('reCAPTCHA site key not configured');
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <div className="flex items-center">
          <div className="text-yellow-600">
            ⚠️ reCAPTCHA not configured (development mode)
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={siteKey}
        onChange={handleChange}
        onExpired={handleExpired}
        onError={handleError}
        size={size}
        theme={theme}
      />
    </div>
  );
};

export default RecaptchaComponent;
